import React, { useEffect } from 'react';
import { Grid, Typography, Box, Divider, Skeleton } from '@mui/material';
import { ButterflyChart } from '../../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { getDigitalVsNonDigitalAffinity,getTopStatesByIndividuals } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';

const DigitalVsNonDigitalAffinity = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { digitalVsNonDigital } = useSelector(state => state.physicianTargetListAnalysis)
    const { chartSeries, isLoading } = digitalVsNonDigital;

    useEffect(() => {
        if(company.id){
            dispatch(getDigitalVsNonDigitalAffinity({companyId: company.id}))
        }
        
    },[company.id])

    return (
        <Box className="box-sizing-border-box br-16px border-1-gray">
            <Box className="flex-row-space-between padding-24px border-bottom-gray ">
                <Typography className="text-lg-semi-bold gray-900">
                    Broad Affinity
                </Typography>
            </Box>
            <Grid container>
                <Grid item xs={12} className={`flex-row-justify-center ${isLoading && "padding-24px"}`}>
                    <Box className="w-100 padding-tb-0-rl-9">
                    {isLoading ? <Skeleton variant='rectangular' width={'100%'} height={380}/> :
                        <ButterflyChart categories={chartSeries?.categories} seriesData={chartSeries?.seriesData}/>
                    }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DigitalVsNonDigitalAffinity;
